/*
 * @FileName       : ui.reducer.ts
 * @Version        : 1.0
 * @DateOfCreation : 04/21/2020
 * @Author         : $u^^!t @ FFF Enterprises
 * @Dependencies   : N/A
 * @Description    : UI reducer to handle UI events.
 *
 * Copyright (c) 2020, FFF Enterprises. All rights reserved.
 */

import createReducer from './createReducer';
import { UIActions } from '../actions';
import { UI } from '../constants/actions';


export const ui = createReducer({}, {
  [UI.SET_NAV_STATE](state = {}, action: ReturnType<typeof UIActions.setNavState>) {
    return { ...state, navState: action.payload }
  },

  [UI.NAVIGATE_RESPONSE](state = {}, action: ReturnType<typeof UIActions.navigationStateSuccess>) {
    return { ...state, menuState: action.payload }
  },

  [UI.SHOW_LOADER](state = {}, action: ReturnType<typeof UIActions.showLoader>) {
    return { ...state, isLoading: action.payload }
  },

  [UI.AUTH_PROCESSING](state = {}, action: ReturnType<typeof UIActions.setAuthProcessing>) {
    return { ...state, authProcessing: action.payload }
  },

  [UI.SET_API_ERROR](state = {}, action: ReturnType<typeof UIActions.setApiError>) {
    return { ...state, errorMessage: action.payload }
  },

  [UI.SET_NAV_DRAWER](state = {}, action: ReturnType<typeof UIActions.setNavDrawer>) {
    return { ...state, navDrawerOpen: action.payload }
  },

  [UI.SET_GLOBAL_ROWS_PER_PAGE](state = {}, action: ReturnType<typeof UIActions.setGlobalRowsPerPage>) {
    return { ...state, globalRowsPerPage: action.payload }
  },

  [UI.SET_URL_FILTER](state = {}, action: ReturnType<typeof UIActions.setUrlFilter>) {
    const queryString = action.payload ? action.payload.replace('?', '') : null
    const params = new URLSearchParams(queryString)
    if (params.get('filter')) {
      const filterString: any = params.get('filter');
      let filter = null;

      try {
        let c = filterString.replace(/[\u200B-\u200D\uFEFF]/g, ''); //replace zero width spaces if present!!
        filter = JSON.parse(decodeURI( c ));
      }
      catch (e) {
        console.error('Error parsing filter json from url:', e);
      }

      return { ...state, urlFilter: filter }
    }

    return { ...state, urlFilter: null }
  },

  [UI.SESSION_EXPIRED](state = {}, action: ReturnType<typeof UIActions.setSessionExpired>) {
    return { ...state, sessionExpired: action.payload }
  },
  
  [UI.SET_CUSTOMERS](state = {}, action: ReturnType<typeof UIActions.setPreloadedCustomers>) {
    return { ...state, customers: action.payload }
  },
  [UI.SET_PRELOADED_SERVICE_TYPES](state = {}, action: ReturnType<typeof UIActions.setPreloadedServiceTypes>) {
    return { ...state, serviceTypes: action.payload || [] }
  },
  [UI.PRELOAD_DATA](state = {}, action: ReturnType<typeof UIActions.preLoadData>) {
    return { ...state, dataIsPreloaded: true }
  },
  [UI.SET_BACKEND_POLLER](state = {}, action: ReturnType<typeof UIActions.setBackendPoller>) {
    return { ...state, backendPoller: action.payload }
  },
});